export default {
  FoveonicsAPI: "https://api.documentsync.com",
  ImageViewer: "https://viewer.documentsync.com",
  templateSearchDescription: {
    "hillsboroughapi@documentsync.com": {
      inxConstruction_Permit_Applications_1084:
        "Search construction permit applications from 2009 - 2016",
      inxMeeting_Minutes_1088: "Search on meeting minutes from 1936 - 1999",
      inxOrdinances_1085: "Search on ordinances from 1957 - 2008",
    },
    // "testapi@documentsync.com": {
    //   inxApplications_1144: "Applications",
    //   inxViolations_1143: "Violations",
    // },
  },
};
